<template>
  <div>
    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Responsável"
                v-model="current.responsable"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>

          <v-tabs v-model="tab" grow class="mt-2">
            <v-tab key="dy"> Cadastro </v-tab>
            <v-tab key="ot"> Endereço </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="dy">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CPF/CNPJ"
                        v-model="current.register"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="RG/IE"
                        v-model="current.register2"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CFOP"
                        v-model="current.cfop"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-menu
                        v-model="menu_birth"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="birthText"
                            label="Nasc./Fund."
                            placeholder="dd/mm/aaaa"
                            :error-messages="birthError"
                            @blur="birthDigitada()"
                            outlined
                            dense
                          >
                            <template v-slot:append>
                              <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="current.birth"
                          @input="birthAlterada()"
                          locale="pt-br"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Telefone"
                        v-model="current.telephone"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Celular"
                        v-model="current.cellphone"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Fax"
                        v-model="current.fax"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Email"
                        v-model="current.email"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Site"
                        v-model="current.site"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-textarea
                        label="Emails adicionais"
                        v-model="current.emailExtra"
                        outlined
                        dense
                      ></v-textarea>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-textarea
                        label="Observações"
                        v-model="current.obs"
                        outlined
                        dense
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="ot">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="current.address"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="current.addressNumber"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="current.addressExtra"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="current.addressNeighborhood"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="current.city"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="current.province"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="current.country"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="current.zipcode"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    tab: null,
    menu_birth: false,
    birthText: "",
    birthError: "",
    dialog_loading: false,
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/client/0", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao gerar formulario de cadastro!");
          console.log(error);
        });
    },
    save: function () {
      var me = this;
      var token = localStorage.getItem("token");
      if (me.birthError) {
        alert("Corrija a data de nascimento/fundação!");
        return;
      }
      me.dialog_loading = true;
      api
        .post("/client", this.current, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Cliente cadastrado com sucesso!");
          router.push({ path: "/client" });
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar formulario de cadastro!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate: function (text) {
      // aceita "dd/mm/aaaa" ou só os dígitos "ddmmaaaa"
      const digits = text.replace(/\D/g, "");
      if (digits.length !== 8) return null;
      const day = digits.substr(0, 2);
      const month = digits.substr(2, 2);
      const year = digits.substr(4, 4);
      const d = new Date(year, month - 1, day);
      if (
        d.getFullYear() != year ||
        d.getMonth() + 1 != month ||
        d.getDate() != day
      )
        return null;
      return `${year}-${month}-${day}`;
    },
    birthAlterada: function () {
      this.menu_birth = false;
    },
    birthDigitada: function () {
      const text = (this.birthText || "").trim();
      if (!text) {
        this.birthError = "";
        this.current.birth = null;
        return;
      }
      const iso = this.parseDate(text);
      if (!iso) {
        this.birthError = "Data inválida (dd/mm/aaaa)";
        return;
      }
      this.birthError = "";
      this.current.birth = iso;
      this.birthText = this.formatDate(iso);
    },
  },
  watch: {
    "current.birth": function (value) {
      this.birthText = this.formatDate(value) || "";
      this.birthError = "";
    },
  },
};
</script>